import React, { Fragment, useState } from "react";

//package import

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  useTheme,
  Typography,
  Box,
} from "@mui/material";

import { NavLink, useLocation } from "react-router-dom";

//user import

import {
  RoutesUrls,
  provinceRoutes,
  commonRoutes,
} from "../../../../Services/Routes/APP";
import {
  DashBoardIcon,
  DistrictsIcon,
  PointOfUseIcon,
  BatchIcon,
  SettingIcon,
  InventoryMenuIcon,
  RequestIcon,
  Logo,
  Nodes,
} from "../../../../Svg";
import { Circle } from "@mui/icons-material";

//constants

const sideList = [
  {
    id: 331,
    title: "Dashboard",
    icon: <DashBoardIcon />,
    link: provinceRoutes?.dashboard,
  },
  {
    id: 332,
    title: "Districts",
    icon: <DistrictsIcon />,
    link: provinceRoutes?.districts,
  },
  {
    id: 433,
    title: "Clinics",
    icon: <PointOfUseIcon />,
    link: provinceRoutes?.pointOfUse,
  },
  {
    id: 334,
    title: "Inventory",
    icon: <InventoryMenuIcon />,
    categories: [
      {
        title: "Vaccines",
        link: provinceRoutes?.batch,
      },

      {
        title: "Others",
        link: "#",
      },
    ],
  },
  {
    id: 334,
    title: "Requests",
    icon: <RequestIcon />,
    categories: [
      {
        title: "Sent",
        link: provinceRoutes?.requests,
      },
      {
        title: "Received",
        link: provinceRoutes?.requests,
      },
      {
        title: "Request inventory",
        link: provinceRoutes?.request_inventory,
      },
    ],
  },
  {
    id: 335,
    title: "Setting",
    icon: <SettingIcon />,
    link: provinceRoutes?.setting,
  },
  {
    id: 437,
    title: "Node View",
    icon: <Nodes />,
    link: commonRoutes?.nodeView,
  },
];

//component

export const InsideDrawer = () => {
  //hooks

  const theme = useTheme();
  const location = useLocation();

  let navigationsArray = location?.pathname?.split("/") || [];

  navigationsArray?.reverse().pop();
  const urlNavPoints = navigationsArray;
  const urlEndingPoint = urlNavPoints[0];

  //states
  const [navbarEl, setNavbarEl] = useState(
    `${sideList[0]?.id}-user-route-${0}`
  );
  const [open, setOpen] = useState("");

  //render

  return (
    <Box>
      <Box padding={4}>
        <Typography
          color={"common.white"}
          variant="h4"
          fontWeight={"bold"}
          align="center"
        >
          <Logo />
        </Typography>
      </Box>
      <List>
        {sideList?.map((item, itemIndex) => (
          <NavLink
            key={`${item?.id}-user-route-${itemIndex}`}
            to={item?.categories ? "#" : RoutesUrls?.provinceAdmin + item?.link}
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
            component={item?.categories ? "button" : "a"}
            className={"active_link"}
          >
            <ListItemButton
              sx={{
                backgroundColor: "transparent",

                padding: theme.spacing(1.5, 1.5, 1.5, 4),
                "&.Mui-selected": {
                  backgroundColor: "inherit !important",
                },
              }}
              onClick={() => {
                const NAVBAR_EL = `${item?.id}-user-route-${itemIndex}`;
                if (item?.categories) {
                  setOpen(open && open === NAVBAR_EL ? null : NAVBAR_EL);
                } else {
                  setNavbarEl(NAVBAR_EL);
                }
              }}
              selected={
                item?.link?.replace("/", "") === urlEndingPoint ||
                item?.categories?.filter((cat) => {
                  return cat?.itemLink === urlEndingPoint;
                }).length
              }
            >
              <ListItemIcon sx={{ color: "inherit" }}>
                {item?.icon}
              </ListItemIcon>
              <ListItemText
                primary={item?.title}
                sx={{
                  color: theme.palette.common.white,
                }}
              />
            </ListItemButton>
            {item?.categories && (
              <Collapse in={`${item?.id}-user-route-${itemIndex}` === open}>
                <List disablePadding>
                  {item?.categories?.map((category, index) => (
                    <NavLink
                      key={`${category?.title}-user-route-${index}`}
                      to={
                        category?.link === "#"
                          ? "#"
                          : RoutesUrls?.provinceAdmin + category?.link
                      }
                      state={{ type: category.title.toLowerCase() }}
                      style={{
                        textDecoration: "none",
                        textSizeAdjust: "small",
                      }}
                      className={"active_link"}
                    >
                      <ListItem
                        sx={{
                          backgroundColor: "transparent",
                          color: "#96abd5",
                          padding: theme.spacing(0.8, 1, 0, 9),
                          "&.Mui-selected": {
                            backgroundColor: "transparent",
                            color: "white",
                          },
                        }}
                        button
                        selected={
                          location?.state?.type ===
                          category?.title?.toLowerCase()
                        }
                        onClick={() => {
                          setNavbarEl(`${item?.id}-user-route-${itemIndex}`);
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color: "inherit",
                          }}
                        >
                          <Circle style={{ transform: "scale(0.6)" }} />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography style={{}}>
                              {category?.title}
                            </Typography>
                          }
                          sx={{
                            margin: "-1.5rem",
                          }}
                        />
                      </ListItem>
                    </NavLink>
                  ))}
                </List>
              </Collapse>
            )}
          </NavLink>
        ))}
      </List>
    </Box>
  );
};
